// Supabase configuration — reads from environment variables at build time.
// Falls back to hardcoded defaults for backward compatibility.
// To override, set VITE_SUPABASE_PROJECT_ID and VITE_SUPABASE_ANON_KEY in your .env file.

export const projectId: string =
  (import.meta as any).env?.VITE_SUPABASE_PROJECT_ID || "dnaoymupfdnulzpegopv";

export const publicAnonKey: string =
  (import.meta as any).env?.VITE_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRuYW95bXVwZmRudWx6cGVnb3B2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE2NTM5ODAsImV4cCI6MjA4NzIyOTk4MH0.iGtawLwmz55LoNU4_o04vxHivHYg26gzN0VRtSv0kQI";
